import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private activeRequests = signal(0);
  private key = signal(0);

  public readonly elementsReady = computed(() => this.activeRequests() === 0);

  loading = computed(() => this.activeRequests() > 0);
  spinnerKey = computed(() => this.key());

  show() {
    this.activeRequests.update((count) => count + 1);
    this.key.update((k) => k + 1);
  }

  hide() {
    this.activeRequests.update((count) => Math.max(0, count - 1));
  }
}
